import { supabase } from "@/integrations/supabase/client";

export interface Invoice {
  id: string;
  payment_id: string;
  reservation_id: string;
  stripe_invoice_id: string | null;
  invoice_number: string;
  invoice_pdf_path: string | null;
  amount: number;
  created_at: string;
  updated_at: string;
  archived_at: string | null;
}

export const getInvoicesByReservation = async (reservationId: string): Promise<Invoice[]> => {
  const { data, error } = await supabase
    .from('invoices')
    .select('*')
    .eq('reservation_id', reservationId)
    .order('created_at', { ascending: false });
    
  if (error) throw error;
  return data as Invoice[];
};

export const getInvoicesByClient = async (clientEmail: string): Promise<Invoice[]> => {
  const { data, error } = await supabase
    .from('invoices')
    .select(`
      *,
      reservations!inner (
        email
      )
    `)
    .eq('reservations.email', clientEmail)
    .order('created_at', { ascending: false });
    
  if (error) throw error;
  return data as Invoice[];
};

export const downloadInvoicePDF = async (pdfPath: string): Promise<Blob> => {
  const { data, error } = await supabase.storage
    .from('invoices')
    .download(pdfPath);
    
  if (error) throw error;
  return data;
};

export const getInvoicePDFUrl = async (pdfPath: string): Promise<string> => {
  const { data, error } = await supabase.storage
    .from('invoices')
    .createSignedUrl(pdfPath, 3600); // 1 hour expiry

  if (error) throw error;
  if (!data?.signedUrl) throw new Error('URL signée non générée');
  return data.signedUrl;
};